import { useEffect, useState } from 'react'
import { DESKTOP_XMD_BREAKPOINT_PX, MEDIA_QUERY_MIN_DESKTOP_XMD } from '../../../constants/breakpoints'

export type BlackButtonType = {
  label: string
  subLabel?: string
  subLabelParts?: [string, string?]
  subLabelBreakpointPx?: number
  shouldSplitSubLabel?: boolean
  iconSrc: string
  iconWidth: string
  iconHeight: string
  buttonWidth?: string
  onClickHandle?: () => void
  isAuth?: boolean
}

export function BlackButton(props: BlackButtonType) {
  const hasResponsiveSubLabel = Array.isArray(props.subLabelParts) && props.subLabelParts.length >= 1
  const shouldSplitSubLabel = props.shouldSplitSubLabel ?? true

  const breakpointPx = props.subLabelBreakpointPx ?? DESKTOP_XMD_BREAKPOINT_PX
  const [isInlineSubLabel, setIsInlineSubLabel] = useState(() => {
    if (!hasResponsiveSubLabel || !shouldSplitSubLabel) return true
    if (typeof window === 'undefined') return true
    return window.innerWidth >= breakpointPx
  })

  useEffect(() => {
    if (!hasResponsiveSubLabel || !shouldSplitSubLabel) return
    const media = window.matchMedia(props.subLabelBreakpointPx ? `(min-width: ${breakpointPx}px)` : MEDIA_QUERY_MIN_DESKTOP_XMD)
    const handleChange = () => setIsInlineSubLabel(media.matches)
    handleChange()
    media.addEventListener('change', handleChange)
    return () => {
      media.removeEventListener('change', handleChange)
    }
  }, [hasResponsiveSubLabel, breakpointPx, shouldSplitSubLabel])

  const renderSubLabel = () => {
    if (hasResponsiveSubLabel && props.subLabelParts) {
      const [first, second] = props.subLabelParts
      if (shouldSplitSubLabel && second) {
        return (
          <span
            className="text-[#F3F3F3] text-[10px] mt-[3px] flex w-full desktop-xmd:ml-2.5"
            style={{
              flexDirection: isInlineSubLabel ? 'row' : 'column',
            }}
          >
            <span>{first}</span>
            <span>{second}</span>
          </span>
        )
      }
      return (
        <span className="text-[#F3F3F3] text-[10px] ml-2.5 mt-[3px]">
          {second ? `${first}${second}` : first}
        </span>
      )
    }
    if (props.subLabel) {
      return <span className="text-[#F3F3F3] text-[10px] ml-2.5 mt-[3px]">{props.subLabel}</span>
    }
    return null
  }

  return (
    <button
      onClick={() => {
        if (!props.isAuth || !props.onClickHandle) return
        props.onClickHandle()
      }}
      className={`flex flex-col items-start justify-center bg-[#151515] h-[60px] w-full min-w-fit pt-[5px] px-2.5 rounded-lg desktop-xmd:pt-2.5 desktop-xmd:justify-start ${!props.isAuth && 'cursor-not-allowed'}`}
      disabled={!props.isAuth}
    >
      <div className="flex">
        <img src={props.iconSrc} alt="" className='w-[15px] h-[15px] desktop-xmd:w-[21px] desktop-xmd:h-[21px]' />
        <span className="text-[11px] ml-[3px] font-semibold desktop-xmd:text-sm desktop-xmd:ml-1">{props.label}</span>
      </div>
      {renderSubLabel()}
    </button>
  )
}
